import { useGoToPath } from '@/utils/hooks/useGoToPath'
import styled from 'styled-components'
import { Column, ModalBase, Typography } from '@/components'
import { PoaResignReason } from '@/types/company'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const ModalBody = styled(Column)`
  gap: 24px;
`

const translationsMap = {
  [PoaResignReason.NAME_CHANGED]: 'nameChanged',
  [PoaResignReason.ADDRESS_CHANGED]: 'addressChanged',
  [PoaResignReason.MD_CHANGED]: 'mdChanged',
  [PoaResignReason.MULTIPLE_CHANGED]: 'multipleChanged',
}

export const CompanyDetailsChangedModal = ({
  poaResignReason,
  companyId,
}: {
  poaResignReason: PoaResignReason
  companyId: string
}) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(true)

  const goToPoa = useGoToPath(`/company/poa/${companyId}`)

  const handleOnClose = () => {
    setIsOpen(false)
  }

  const redirectToPoa = () => {
    setIsOpen(false)
    goToPoa()
  }

  const modalContent = translationsMap[poaResignReason]
    ? t(`poaResignModal.${translationsMap[poaResignReason]}`)
    : t(`poaResignModal.multipleChanged`)

  return (
    <ModalBase
      closable
      isOpen={isOpen}
      onClose={handleOnClose}
      primaryText={t('poaResignModal.primaryButtonText')}
      secondaryText={t('poaResignModal.secondaryButtonText')}
      onPrimaryClick={redirectToPoa}
    >
      <ModalBody>
        <Typography variant="itemTitle" bold>
          {t('poaResignModal.title')}
        </Typography>
        <div>{modalContent}</div>
      </ModalBody>
    </ModalBase>
  )
}
